import { getReports } from "@/requestFunc"

export default {
	actions: {
		async getReports(context, DEAL_LIST) {
			let getReportsReq = await getReports()
			if (getReportsReq.ok) {
				try {
					let res = await getReportsReq.json()
					context.commit('setCategories', res.info.categories)
					context.commit('setDeals', {dealList:DEAL_LIST,needDeals:Object.keys(res.file)})
					context.commit('setReports', res.file)
				} catch (error) {
					console.error("getReports error", error)
				}
			}
		},
	},
	mutations: {
		setReports(state, cacheList) {
			let reports = []
			let key = 0;
			for (let deal in cacheList) {
				//if (!state.deals[deal] || !state.categories[state.deals[deal].CATEGORY_ID]) continue
				let tableItem = {
					key: key++,
					deal,
					title:state.deals[deal].TITLE,
					category: state.deals[deal].CATEGORY_ID,
					children: [],
					budget: 9000,
					brutto:{invoices:0,sales:0,total:0}
				}
				for (let dealType in cacheList[deal]) {
					let invoices = 0, sales = 0,total = 0
					for (let file of cacheList[deal][dealType]) {
						if (file.typeInvoice == 'Kosztowe'){
							invoices += +file.brutto
						}else if (file.typeInvoice ==  'Sprzedazowe'){
							sales += +file.brutto
						}
					}
					total = sales - invoices
					tableItem.children.push({
						key: key++,
						title:dealType,
						brutto:{invoices,sales,total}
					})
					tableItem.brutto.invoices += invoices
					tableItem.brutto.sales += sales
					tableItem.brutto.total += total
				}
				reports.push(tableItem)
			}
			state.reports = reports
		},
		setDeals(state, {dealList = {},needDeals = []}) {

			let deals = {}
			for(let id of needDeals){
				if (id in dealList) deals[id] = dealList[id]	
			}
			state.deals = deals
		},
		setCategories(state,categories){
			let categoryList = {}
			for(let i of categories){
				categoryList[i.ID] = i
			}
			state.categories = categoryList
		}
	},
	state: {
		reports: [],
		deals: [],
		categories: [],
	},
	getters: {
		Reports(state) {
			return state.reports
		},
		NeedDeals(state) {
			return state.deals
		},
		Categories(state){
			return state.categories
		}
	}
}
